import React, { useEffect, useRef, useState } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { useParams } from "react-router";
import axios from "axios";
import { BASE_URL } from "../../App";
import "../../styles/video.css";
import { Col, Container, Row } from "react-bootstrap";
import { extractYoutubeId } from "../../utils/youtubeId";

/** Turn off YouTube CC inside the iframe (no CSS overlay). */
function disableYoutubeCaptions(player) {
  try {
    player.captions.toggle(false, false);
  } catch {
    /* ignore */
  }

  const yt = player.embed;
  if (!yt || typeof yt.setOption !== "function") return;

  try {
    yt.setOption("captions", "track", null);
  } catch {
    /* ignore */
  }

  try {
    if (typeof yt.unloadModule === "function") {
      yt.unloadModule("captions");
    }
  } catch {
    /* ignore */
  }
}

const VideoPlayer = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const playerRef = useRef(null);
  const captionGuardRef = useRef(null);

  const youtubeId = video?.iframe ? extractYoutubeId(video.iframe) : "";

  useEffect(() => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "any",
        Authorization: `Bearer ${token}`,
      },
    };

    setLoading(true);
    axios
      .get(`${BASE_URL}/api/user/enrollVideo/${id}`, config)
      .then((response) => {
        setVideo(response.data.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F12" || event.altKey) {
        event.preventDefault();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const handleContextmenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);
    return () => document.removeEventListener("contextmenu", handleContextmenu);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (loading || !youtubeId) return;

    const timer = window.setTimeout(() => {
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }

      const player = new Plyr("#player", {
        iconUrl: `${process.env.PUBLIC_URL || ""}/plyr.svg`,
        loadSprite: true,
        controls: [
          "play-large",
          "rewind",
          "play",
          "fast-forward",
          "progress",
          "current-time",
          "mute",
          "volume",
          "settings",
          "pip",
          "airplay",
          "fullscreen",
        ],
        seekTime: 10,
        settings: ["quality", "speed", "loop"],
        captions: {
          active: false,
          update: false,
        },
        storage: {
          enabled: false,
        },
        clickToPlay: true,
        youtube: {
          noCookie: false,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          fs: 0,
          cc_load_policy: 0,
        },
        loop: { active: false },
      });

      player.on("contextmenu", (e) => e.preventDefault());

      const guardCaptions = () => disableYoutubeCaptions(player);

      player.on("ready", () => {
        guardCaptions();
        if (captionGuardRef.current) {
          window.clearInterval(captionGuardRef.current);
        }
        captionGuardRef.current = window.setInterval(guardCaptions, 400);
        window.setTimeout(() => {
          if (captionGuardRef.current) {
            window.clearInterval(captionGuardRef.current);
            captionGuardRef.current = null;
          }
        }, 8000);
      });
      player.on("play", guardCaptions);
      player.on("playing", guardCaptions);
      player.on("languagechange", guardCaptions);

      playerRef.current = player;
    }, 0);

    return () => {
      window.clearTimeout(timer);
      if (captionGuardRef.current) {
        window.clearInterval(captionGuardRef.current);
        captionGuardRef.current = null;
      }
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [loading, youtubeId]);

  return (
    <div className="video">
      <div className="button-courses">
        <button className="button-50" type="button">
          {video?.title || ""}
        </button>
      </div>
      <Container>
        <Row>
          <Col lg={9} className="ms-auto me-auto">
            {loading && (
              <div className="video-loading">جاري تحميل الفيديو...</div>
            )}
            {!loading && !youtubeId && (
              <div className="video-loading">رابط الفيديو غير صالح</div>
            )}
            {!loading && youtubeId && (
              <div className="video-embed-player">
                <div
                  key={youtubeId}
                  id="player"
                  data-plyr-provider="youtube"
                  data-plyr-embed-id={youtubeId}
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VideoPlayer;
